module.exports = __webpack_public_path__ + "img/create-treatment-button-desktop-en.8e4a38e8.jpg";